import React from "react";
import { cn } from "../../lib/utils";
import { SITE_CONFIG, REGIONAL_BRIEFS } from "../../lib/constants";

export function Footer({ className }) {
  const currentYear = new Date().getFullYear();
  const otherRegions = REGIONAL_BRIEFS.filter((r) => !("active" in r));

  return (
    <footer
      className={cn(
        "bg-ink text-paper",
        "py-12 md:py-16 px-4",
        className
      )}
    >
      <div className="max-w-5xl mx-auto">
        {/* Main Footer Content */}
        <div className="text-center mb-10">
          <h2 className="font-serif text-2xl md:text-3xl font-bold text-paper! mb-2">
            {SITE_CONFIG.name}
          </h2>
          <p className="text-paper/70 font-body">
            {SITE_CONFIG.tagline}
          </p>
        </div>

        {/* Divider */}
        <div className="flex items-center justify-center gap-4 my-8">
          <div className="flex-1 h-px bg-gradient-to-r from-transparent to-ink-muted" />
          <div className="w-2 h-2 bg-gold rotate-45" />
          <div className="flex-1 h-px bg-gradient-to-l from-transparent to-ink-muted" />
        </div>

        {/* Other Regional Briefs */}
        <div className="text-center mb-10">
          <p className="font-sans text-xs uppercase tracking-widest text-ink-light mb-4">
            Other Regional Briefs
          </p>
          <div className="flex flex-wrap items-center justify-center gap-4 md:gap-6">
            {otherRegions.map((region) => (
              <a
                key={region.id}
                href={region.href}
                className={cn(
                  "font-sans text-sm text-paper/80",
                  "hover:text-gold transition-colors duration-300",
                  "underline-draw"
                )}
              >
                {region.fullName}
              </a>
            ))}
          </div>
        </div>

        {/* Logos */}
        <div className="flex items-center justify-center gap-8 md:gap-12 mb-10">
          <div className="text-center">
            <p className="font-sans text-xs text-ink-light mb-2">
              A publication of
            </p>
            <img
              src="/logos/ankhlogo.png"
              alt="Ankh Resources"
              className="h-10 w-auto object-contain opacity-90 hover:opacity-100 transition-opacity"
            />
          </div>
          <div className="w-px h-12 bg-ink-muted" />
          <div className="text-center">
            <p className="font-sans text-xs text-ink-light mb-2">
              Powered by
            </p>
            <img
              src="/logos/New Logonobg.png"
              alt="Omniscan AI"
              className="h-8 w-auto object-contain opacity-90 hover:opacity-100 transition-opacity"
            />
          </div>
        </div>

        {/* Copyright */}
        <div className="text-center pt-8 border-t border-ink-muted/30">
          <p className="font-sans text-xs text-ink-light">
            &copy; {currentYear} {SITE_CONFIG.copyright}. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
}
